import React, { Component } from 'react';
import axios from 'axios';
import {
    ContextualMenu, ContextualMenuItemType, ConstrainMode,
    DirectionalHint, DetailsListLayoutMode,
    Label, Link, Separator,
    Stack, Spinner, SpinnerSize,
    ShimmeredDetailsList, Sticky, StickyPositionType,
    SelectionMode, ScrollablePane, ScrollbarVisibility,
    DefaultButton, PanelType, Panel, PrimaryButton,
        IRenderFunction, IDetailsHeaderProps
} from 'office-ui-fabric-react';
import Moment from 'moment';
import { MatterItemDateText } from './Vertical-Timeline/CustomFuntion';

import { EventEmitter } from './events';

import Filters from './filters';

const stackTokens = {
    childrenGap: 10,
    padding: 10
};
const DEFAULT_MATTERS_PER_PAGE = 100;
const DOCUMENT_REQUEST_CONCURRENCY = 8;

interface IFilterType {
    column: string;
    values: [];
}

class MyMatterList extends Component {

    _tempFilter: IFilterType[];
    _requestId = 0;

    constructor(props: any) {
        super(props);

        const columns = [
            {
                key: 'matter_code',
                name: 'Matter ID',
                fieldName: 'matter_code',
                minWidth: 100,
                maxWidth: 100,
                data: 'string',
                isHidden: false,
                isFilterable: false,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false,
                onRender: (item: any) => {
                    return <div className='matter-holder'>
                        <div className='matter-item'><Link type='submit' href={this.state.documentURL + "/Matter?matterCode=" + item.matter_code + "#/Documents"} target="_blank">{item.matter_code}</Link></div>
                    </div>;
                }
            },
            {
                key: 'description',
                name: 'Description',
                fieldName: 'description',
                data: 'string',
                minWidth: 200,
                isHidden: false,
                isFilterable: false,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false,
                onRender: (item: any) => {
                    return <div title={item.description}>
                        {item.description}
                    </div>
                }
            },
            {
                key: 'office',
                name: 'Office',
                fieldName: 'office',
                data: 'string',
                isHidden: false,
                isFilterable: true,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false
            },
            {
                key: 'country',
                name: 'Jurisdiction',
                fieldName: 'country',
                data: 'string',
                isHidden: true,
                isFilterable: true,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false
            },
            {
                key: 'client_name',
                name: 'Client',
                fieldName: 'client_name',
                data: 'string',
                isHidden: true,
                isFilterable: false,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false
            },
            {
                key: 'date_opened',
                name: 'Date',
                fieldName: 'date_opened',
                data: 'date',
                isHidden: false,
                isFilterable: true,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: true,
                onRender: (item: any) => MatterItemDateText(item.date_opened)
            },
            {
                key: 'financial_3e_status',
                name: 'Financial 3E Status',
                fieldName: 'financial_3e_status',
                data: 'string',
                minWidth: 140,
                isHidden: false,
                isFilterable: true,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false
            },
            {
                key: 'business_action_status',
                name: 'Business Action Status',
                fieldName: 'business_action_status',
                data: 'string',
                minWidth: 160,
                isHidden: false,
                isFilterable: true,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false
            },
            {
                key: 'documents_last_created_date',
                name: "Documents' Last Created Date",
                fieldName: 'documents_last_created_date',
                data: 'date',
                minWidth: 170,
                isHidden: false,
                isFilterable: true,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false,
                onRender: (item: any) => item.documents_last_created_date
                    ? MatterItemDateText(item.documents_last_created_date)
                    : ''
            },
            {
                key: 'documents_last_created_by',
                name: "Documents' Last Created By",
                fieldName: 'documents_last_created_by',
                data: 'string',
                minWidth: 180,
                isHidden: false,
                isFilterable: true,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false
            }
        ];

        this._tempFilter = [];

        this.state = {
            items: [],
            displayItems: [],
            currentPage: 1,
            pageSize: DEFAULT_MATTERS_PER_PAGE,
            hasMore: false,
            totalCount: null,
            loadError: '',
            columns: [],
            tempColumns: columns,
            activeCols: [
                'matter_code', 'description', 'office', 'date_opened',
                'financial_3e_status', 'business_action_status',
                'documents_last_created_date', 'documents_last_created_by'
            ],
            settingsMenu: [],
            blocking: true,
            contextualMenuProps: ContextualMenu,
            token: '',
            name: '',
            image: '',
            userName: '',
            userId: '',
            originalURL: '',
            formActionURL: '',
            formTarget: '',
            openPanel: false,
            filterColumn: [],
            filterColumnName: '',
            prevDisplayItems: [],
            documentURL: '',
            matterlistUrl: '',
            latestMatterDocumentsUrl: '',
            matterDocumentsApiCode: ''
        };

        EventEmitter.subscribe('apply-filters', (param: any) => {
            this._tempFilter = param;
        });
    }

    componentDidMount() {
        this.getUserCredentials().then(res => {
            let user = JSON.parse(res);
            this.setState({
                userName: user.userName,
                userId: user.name
                //userName: 'ebarroga91@rouse.com',
            }, () => {
                this.getAPI().then(apiRes => {
                    let api = JSON.parse(apiRes);
                    this.setState({
                        documentURL: api.matterdetail,
                        matterlistUrl: api.matterlistUrl,
                        latestMatterDocumentsUrl: api.latestMatterDocumentsUrl,
                        matterDocumentsApiCode: api.matterDocumentsApiCode
                    }, () => {
                        this._getDataList(1);
                    })
                })
            });
        });
    }

    getUserCredentials() {
        return new Promise(resolve => {
            resolve(
                localStorage.getItem("userSession")
            );
        });
    }

    getAPI() {
        return new Promise(resolve => {
            resolve(
                localStorage.getItem("api")
            );
        });
    }

    _getDataList = (page: any) => {
        this.createColumns();
        const requestId = ++this._requestId;
        this.setState({ blocking: true, loadError: '' });

        const param = {
            token: '32e5ae47-8d89-4422-9004-8a238f1707fb',
            filter: 'mycases',
            userId: this.state.userId,//'ebarroga91@rouse.com',
            casemanager: this.state.userName,//'ebarroga91@rouse.com'
            PageNumber: page,
            PageSize: this.state.pageSize
        };
        axios.post(this.state.matterlistUrl, JSON.stringify(param))
            .then((response) => {
                if (requestId !== this._requestId) return;
                const result = response.data;
                const rows = result.Items || result.items;
                if (!Array.isArray(rows) || typeof (result.HasMore !== undefined ? result.HasMore : result.hasMore) !== 'boolean') {
                    throw new Error('The matter-list API must return Items and HasMore for paging.');
                }
                const hasMore = result.HasMore !== undefined ? result.HasMore : result.hasMore;
                const reportedTotal = result.TotalCount !== undefined ? result.TotalCount : result.totalCount;
                const totalCount = typeof reportedTotal === 'number' && Number.isInteger(reportedTotal) && reportedTotal >= 0
                    ? reportedTotal
                    : (hasMore ? null : (page - 1) * this.state.pageSize + rows.length);
                const matterItems = rows.map((responseItem: any) => {
                    const matterData = responseItem.data;
                    const financialStatus = matterData.summary.status || 'Closed';
                    const hasBusinessClosureDate = Boolean(
                        matterData.case_details && matterData.case_details.business_closure
                    );

                    const matterItem = {
                        ...matterData.summary,
                        financial_3e_status: financialStatus,
                        business_action_status: hasBusinessClosureDate || financialStatus.toLowerCase() === 'closed'
                            ? 'Closed'
                            : 'Open',
                        documents_last_created_date: '',
                        documents_last_created_by: ''
                    };

                    return matterItem;
                });

                const tempItems = this._sortByDefault(matterItems);
                this.setState({
                    items: tempItems,
                    displayItems: tempItems,
                    prevDisplayItems: tempItems,
                    currentPage: page,
                    hasMore: hasMore,
                    totalCount: totalCount,
                    blocking: false,
                    settingsMenu: this.createSettingsMenu()
                }, () => this._onImplementFilter());

                return this._loadDocumentDetails(matterItems).then(() => {
                    if (requestId !== this._requestId) return;
                    const completedItems = this._sortByDefault(matterItems);
                    this.setState({
                        items: completedItems
                    }, () => this._onImplementFilter());
                });
            })
            .catch((error: any) => {
                if (requestId !== this._requestId) return;
                this.setState({
                    blocking: false,
                    loadError: error.message || 'Could not load matters.',
                    settingsMenu: this.createSettingsMenu()
                });
            })
    }

    _loadDocumentDetails = (matterItems: any[]) => {
        if (!this.state.latestMatterDocumentsUrl) {
            return Promise.resolve();
        }

        let nextIndex = 0;
        const loadNext = (): Promise<void> => {
            if (nextIndex >= matterItems.length) {
                return Promise.resolve();
            }

            const index = nextIndex++;
            return this._getLatestDocumentDetails(matterItems[index].matter_code).then((details: any) => {
                Object.assign(matterItems[index], details);
                return loadNext();
            });
        };

        return Promise.all(Array.from(
            { length: Math.min(DOCUMENT_REQUEST_CONCURRENCY, matterItems.length) },
            () => loadNext()
        ));
    }

    _sortByDefault = (items: any[]) => {
        const statusOrder: { [key: string]: number } = {
            open: 0,
            closed: 1
        };

        return items.slice().sort((firstItem: any, secondItem: any) => {
            const firstStatus = String(firstItem.financial_3e_status || 'Closed').toLowerCase();
            const secondStatus = String(secondItem.financial_3e_status || 'Closed').toLowerCase();
            const firstStatusOrder = statusOrder[firstStatus] !== undefined ? statusOrder[firstStatus] : 2;
            const secondStatusOrder = statusOrder[secondStatus] !== undefined ? statusOrder[secondStatus] : 2;

            if (firstStatusOrder !== secondStatusOrder) {
                return firstStatusOrder - secondStatusOrder;
            }

            const firstBusinessStatus = String(firstItem.business_action_status || 'Closed').toLowerCase();
            const secondBusinessStatus = String(secondItem.business_action_status || 'Closed').toLowerCase();
            const firstBusinessOrder = statusOrder[firstBusinessStatus] !== undefined ? statusOrder[firstBusinessStatus] : 2;
            const secondBusinessOrder = statusOrder[secondBusinessStatus] !== undefined ? statusOrder[secondBusinessStatus] : 2;

            if (firstBusinessOrder !== secondBusinessOrder) {
                return firstBusinessOrder - secondBusinessOrder;
            }

            const firstDocumentDate = Moment(firstItem.documents_last_created_date);
            const secondDocumentDate = Moment(secondItem.documents_last_created_date);
            const firstHasDocumentDate = firstDocumentDate.isValid();
            const secondHasDocumentDate = secondDocumentDate.isValid();

            if (firstHasDocumentDate && secondHasDocumentDate) {
                return secondDocumentDate.valueOf() - firstDocumentDate.valueOf();
            }
            if (firstHasDocumentDate) {
                return -1;
            }
            if (secondHasDocumentDate) {
                return 1;
            }

            return String(firstItem.matter_code || '').localeCompare(String(secondItem.matter_code || ''));
        });
    }

    _getLatestDocumentDetails = (matterCode: string) => {
        const emptyDetails = {
            documents_last_created_date: '',
            documents_last_created_by: ''
        };

        if (!matterCode || !this.state.latestMatterDocumentsUrl) {
            return Promise.resolve(emptyDetails);
        }

        const baseUrl = this.state.latestMatterDocumentsUrl.replace(/\/$/, '');
        const url = baseUrl + '/' + encodeURIComponent(matterCode);

        return axios.get(url, {
            params: {
               code: this.state.matterDocumentsApiCode
            }
        }).then((response) => {
            const files = response.data && response.data.PagedFiles;
            const latestDocument = files && files.length > 0 ? files[0] : null;

            return latestDocument ? {
                documents_last_created_date: latestDocument.CreatedDate || '',
                documents_last_created_by: latestDocument.CreatorName || ''
            } : emptyDetails;
        }).catch(() => emptyDetails);
    }


    onColumnHeaderClick = (ev: any, column: any) => {
        this.setState({
            contextualMenuProps: this.getContextualMenuProps(ev, column)
        });
    }

    getContextualMenuProps(env: any, column: any) {
        const items = [
            {
                key: 'aToZ',
                name: 'Ascending',
                iconProps: { iconName: 'SortUp' },
                canCheck: true,
                disabled: false,
                onClick: () => this.onSortingClicked(column, true)
            },
            {
                key: 'zToA',
                name: 'Descending',
                iconProps: { iconName: 'SortDown' },
                canCheck: true,
                disabled: false,
                onClick: () => this.onSortingClicked(column, false)
            }
        ];

        if (column.isFilterable === true) {
            items.push({
                key: 'filter',
                name: 'Filter by ' + column.name,
                iconProps: { iconName: 'Filter' },
                canCheck: true,
                disabled: false,
                onClick: () => this.onFilterClicked(column)
            });

            items.push({
                key: 'clearFilter',
                name: 'Clear Filter',
                iconProps: { iconName: 'ClearFilter' },
                canCheck: true,
                disabled: column.isFiltered === true ? false : true,
                onClick: () => this.onFilterClear(column)
            });
        }

        return {
            items: items,
            target: env.currentTarget,
            directionalHint: DirectionalHint.bottomLeftEdge,
            onDismiss: () => this.onContextualMenuDismissed()
        };
    }

    onSortingClicked(column: any, isAscending: boolean) {
        let currItems = this.state.displayItems;
        let columns = this.state.columns;
        let isSortedDescending = column.isSortedDescending;


        if (column.isSorted) {
            isSortedDescending = isAscending ? false : true;
        }

        let sortedItem = currItems.slice(0).sort(this.alphabetically(!isSortedDescending, column.key));

        this.setState({
            displayItems: sortedItem,
            columns: columns.map(col => {
                col.isSorted = col.key === column.key;
                if (col.isSorted) {
                    col.isSortedDescending = isSortedDescending;
                }
                return col;
            })
        });
    }

    alphabetically(ascending: any, key: any) {

        return function (a, b) {

            // nulls sort after anything else
            if ((a[key] === null && !ascending) || (b[key] === null && ascending)) {
                return 1;
            }
            else if ((b[key] === null && !ascending) || (a[key] === null && ascending)) {
                return -1;
            }
            // equal items sort equally
            else if (a[key].toLowerCase() === b[key].toLowerCase()) {
                return 0;
            }
            // otherwise, if we're ascending, lowest sorts first
            else if (ascending) {
                return a[key].toLowerCase() < b[key].toLowerCase() ? -1 : 1;
            }
            // if descending, highest sorts first
            else {
                return a[key].toLowerCase() < b[key].toLowerCase() ? 1 : -1;
            }

        };

    }

    onFilterClicked(column: any) {
        this._tempFilter = { column: column.key, values: column.SelectedValues };
        this.setState({
            openPanel: true,
            filterColumn: column,
            filterColumnName: 'Filter By ' + column.name
        });
    }

    onPanelDismissed() {
        this.setState({
            openPanel: false
        });
    }

    onContextualMenuDismissed() {
        this.setState({
            contextualMenuProps: undefined
        });
    }

    createColumns() {
        const generatedColumns = [];

        for (let i = 0; i < this.state.tempColumns.length; i++) {
            if (this.state.tempColumns[i].isHidden === false) {
                generatedColumns.push(this.state.tempColumns[i]);
            }
        }

        this.setState({
            columns: generatedColumns
        });
    }

    _onRowClick = (evt: any) => {
        let matterCode = evt.target.attributes.getNamedItem('data-matter-id').value;
        let userSession = JSON.parse(localStorage.getItem('userSession'));
        let encodedImageString = null;//window.btoa(userSession.image);
        this.setState({
            formActionURL: 'matters-ui-dev.azurewebsites.net/Route/PostToken',
            formTarget: '_blank',
            name: userSession.name,
            token: userSession.token,
            image: encodedImageString,
            userName: userSession.userName,
            userId: userSession.userid,
            originalURL: 'matters-ui-dev.azurewebsites.net' + '/Matter?mattercode=' + matterCode + '#/Documents'
        });
    }

    _createColumnList() {
        const columnList = [];

        for (let i = 0; i < this.state.tempColumns.length; i++) {
            const tempItem = {
                key: this.state.tempColumns[i].fieldName,
                text: this.state.tempColumns[i].name,
                iconProps: { iconName: this.state.tempColumns[i].isHidden ? 'Checkbox' : 'CheckboxComposite' },
                onClick: () => this._onShowHideColumn(this.state.tempColumns[i].key)
            };
            columnList.push(tempItem);
        }

        return columnList;
    }

    _onShowHideColumn = (column: string) => {
        const _tempColumnList = this.state.tempColumns;

        for (let x = 0; x < _tempColumnList.length; x++) {
            if (column === _tempColumnList[x].key) {
                if (_tempColumnList[x].isHidden === false) {
                    _tempColumnList[x].isHidden = true;
                } else {
                    _tempColumnList[x].isHidden = false;
                }
            }
        }

        this.setState({
            settingsMenu: this.createSettingsMenu()
        }, () => this.createColumns());
    }

    _resetCheckbox = () => {
        this.setState({
            settingsMenu: this.createSettingsMenu()
        });

        return;
    }

    createSettingsMenu() {
        const menuItem = [
            {
                key: 'resetColumn',
                text: 'Reset Column State',
                iconProps: { iconName: 'TripleColumn' },
                disabled: false,
                onClick: () => {
                    let _currentColumns = this.state.tempColumns;
                    let currItems = this.state.displayItems;

                    let activCols = this.state.activeCols;
                    var colsCur = [];
                    for (let x = 0; x < _currentColumns.length; x++) {
                        _currentColumns[x].isFiltered = false;
                        _currentColumns[x].SelectedValues = [];

                        let isSortedDescending = _currentColumns[x].isSortedDescending;
                        if (isSortedDescending) {
                            isSortedDescending = false;
                        }

                        let sortedItem = currItems.slice(0).sort(this.alphabetically(!isSortedDescending, _currentColumns[x].key));
                        _currentColumns[x].isSortedDescending = isSortedDescending;
                        _currentColumns[x].isSorted = isSortedDescending;
                        /*Reset default cols*/
                        if (activCols.filter(c => c == _currentColumns[x].key).length > 0) {
                            _currentColumns[x].isHidden = false;
                            colsCur.push(_currentColumns[x]);
                        }
                    }
                    this._tempFilter = [];

                    this.setState({
                        columns: colsCur,
                        displayItems: [],
                    }, function () {
                        this._resetCheckbox();
                        this._onImplementFilter();
                    });

                    
                }
            },
            {
                key: 'columns',
                text: 'Columns',
                iconProps: { iconName: 'TripleColumnEdit' },
                disabled: false,
                subMenuProps: {
                    items: this._createColumnList()
                }
            }
        ];

        return {
            shouldFocusOnMount: false,
            items: menuItem
        };
    }

    onFilterApply() {
        let _currentColumns = this.state.columns;
        for (var x = 0; x < _currentColumns.length; x++) {
            if (_currentColumns[x].key === this._tempFilter.column) {
                const selectedValues = this._tempFilter.values || [];
                _currentColumns[x].isFiltered = selectedValues.length > 0;
                _currentColumns[x].SelectedValues = selectedValues;
                break;
            }
        }
        this.setState({
            columns: _currentColumns,
            openPanel: false
        }, function () {
            this._onImplementFilter();
        });
    }

    _onImplementFilter() {
        const _activeFilters = this.state.columns.filter((column: any) =>
            column.isFiltered && column.SelectedValues && column.SelectedValues.length > 0
        );

        const _filteredItems = this.state.items.filter((item: any) => {
            return _activeFilters.every((filter: any) => {
                if (filter.data === "date") {
                    const itemDate = Moment(item[filter.key]);
                    if (!itemDate.isValid()) {
                        return false;
                    }

                    const startDate = filter.SelectedValues[0]
                        ? Moment(filter.SelectedValues[0]).startOf("day")
                        : null;
                    const endDate = filter.SelectedValues[1]
                        ? Moment(filter.SelectedValues[1]).endOf("day")
                        : null;

                    return (!startDate || !itemDate.isBefore(startDate)) &&
                        (!endDate || !itemDate.isAfter(endDate));
                }

                const itemValue = item[filter.key] == null
                    ? ""
                    : String(item[filter.key]).toLowerCase();
                const selectedValues = filter.SelectedValues.map((value: any) =>
                    value == null ? "" : String(value).toLowerCase()
                );

                return selectedValues.indexOf(itemValue) >= 0;
            });
        });

        this.setState({
            displayItems: _filteredItems
        })
    }

    onFilterClear(column) {
        let _currentColumns = this.state.columns;
        for (let x = 0; x < _currentColumns.length; x++) {
            if (column.key == _currentColumns[x].key) {
                _currentColumns[x].isFiltered = false;
                _currentColumns[x].SelectedValues = [];
                break;
            }
        }
        this._tempFilter = [];

        this.setState({
            columns: _currentColumns,
        }, function () {
            this._onImplementFilter();
        });
    }

    _getPageNumbers = (lastKnownPage: number) => {
        const currentPage = this.state.currentPage;
        const start = Math.max(1, Math.min(currentPage - 2, lastKnownPage - 4));
        const end = Math.min(lastKnownPage, start + 4);
        const pages: Array<number | string> = [];

        if (start > 1) {
            pages.push(1);
            if (start > 2) pages.push('start-ellipsis');
        }
        for (let page = start; page <= end; page++) {
            pages.push(page);
        }
        if (end < lastKnownPage) {
            if (end < lastKnownPage - 1) pages.push('end-ellipsis');
            pages.push(lastKnownPage);
        }

        return pages;
    }

    public render() {
        const { contextualMenuProps } = this.state;
        const totalPages = this.state.totalCount === null
            ? null
            : Math.max(1, Math.ceil(this.state.totalCount / this.state.pageSize));
        const lastKnownPage = totalPages === null
            ? this.state.currentPage + (this.state.hasMore ? 1 : 0)
            : totalPages;

        const onRenderFooterContent = (() => (
            <div>
                <PrimaryButton
                    onClick={() => this.onFilterApply()}
                    style={{ marginRight: '8px' }}
                >
                    Apply
                </PrimaryButton>
                <DefaultButton onClick={() => this.onPanelDismissed()}>Cancel</DefaultButton>
            </div>
        ));

        return (
            <form action={this.state.formActionURL} target={this.state.formTarget} method='post'>
                <input type='hidden' name='token' value={this.state.token}></input>
                <input type='hidden' name='image' value={this.state.image}></input>
                <input type='hidden' name='name' value={this.state.name}></input>
                <input type='hidden' name='userName' value={this.state.userName}></input>
                <input type='hidden' name='originalIUrl' value={this.state.originalURL}></input>
                <input type='hidden' name='userId' value={this.state.userId}></input>

                <div className='my-matters-list'>
                    {this.state.blocking === true ?
                        <Spinner className='list-spinner' size={SpinnerSize.large} label="Loading..." ariaLive="assertive" labelPosition="top" />
                        : ''
                    }
                    {this.state.loadError && <div role="alert">{this.state.loadError}</div>}
                    <div className='settings-menu'>
                        <DefaultButton
                            iconProps={{ iconName: 'Settings' }}
                            menuProps={this.state.settingsMenu}
                            className='menu-button'
                        ></DefaultButton>
                    </div>
                    <div className='list-container'>
                        <Stack horizontal tokens={stackTokens} >
                            <Stack.Item align='stretch'>
                                <ScrollablePane>
                                    <ShimmeredDetailsList
                                        setKey='items'
                                        items={this.state.displayItems}
                                        columns={this.state.columns}
                                        isHeaderVisible={true}
                                        layoutMode={DetailsListLayoutMode.justified}
                                        constrainMode={ConstrainMode.unconstrained}
                                        onColumnHeaderClick={this.onColumnHeaderClick}
                                        selectionMode={SelectionMode.single}
                                        listProps={{ renderedWindowsAhead: 0, renderedWindowsBehind: 0 }}
                                        onRenderDetailsHeader={
                                            (detailsHeaderProps: IDetailsHeaderProps, defaultRender: IRenderFunction<IDetailsHeaderProps>) => (
                                                <Sticky>
                                                    {defaultRender(detailsHeaderProps)}
                                                </Sticky>
                                            )}
                                    />
                                </ScrollablePane>
                                {contextualMenuProps && <ContextualMenu {...contextualMenuProps} />}
                            </Stack.Item>
                        </Stack>
                    </div>
                    {!this.state.blocking && !this.state.loadError &&
                        <nav className='matter-list-pagination' aria-label='My Matters pages'>
                            <label className='matter-list-page-size'>
                                Items per page:
                                <select
                                    value={this.state.pageSize}
                                    onChange={(event) => this.setState(
                                        { pageSize: Number(event.target.value) },
                                        () => this._getDataList(1)
                                    )}
                                >
                                    {[10, 25, 50, 100].map((size) =>
                                        <option key={size} value={size}>{size}</option>
                                    )}
                                </select>
                            </label>
                            <div className='matter-list-page-buttons'>
                                <button type='button' aria-label='First page' disabled={this.state.currentPage === 1} onClick={() => this._getDataList(1)}>«</button>
                                <button type='button' aria-label='Previous page' disabled={this.state.currentPage === 1} onClick={() => this._getDataList(this.state.currentPage - 1)}>‹</button>
                                {this._getPageNumbers(lastKnownPage).map((page) => typeof page === 'number' ?
                                    <button
                                        key={page}
                                        type='button'
                                        aria-label={'Page ' + page}
                                        aria-current={page === this.state.currentPage ? 'page' : undefined}
                                        disabled={page === this.state.currentPage}
                                        onClick={() => this._getDataList(page)}
                                    >{page}</button>
                                    : <span className='matter-list-page-ellipsis' key={page}>…</span>
                                )}
                                <button type='button' aria-label='Next page' disabled={!this.state.hasMore} onClick={() => this._getDataList(this.state.currentPage + 1)}>›</button>
                                <button
                                    type='button'
                                    aria-label={totalPages === null ? 'Last page unavailable until total count is provided' : 'Last page'}
                                    disabled={totalPages === null || this.state.currentPage >= totalPages}
                                    onClick={() => this._getDataList(totalPages)}
                                >»</button>
                            </div>
                        </nav>
                    }
                    <Panel
                        isOpen={this.state.openPanel}
                        onDismiss={() => this.onPanelDismissed()}
                        headerText={this.state.filterColumnName}
                        type={PanelType.custom}
                        customWidth='400px'
                        onRenderFooterContent={onRenderFooterContent}
                        isFooterAtBottom={true}
                    >
                        <Filters
                            items={this.state.filterColumn.isFiltered ? this.state.items : this.state.displayItems}
                            selectedItems={this._tempFilter}
                            column={this.state.filterColumn}
                            tempFilter={this._tempFilter}
                        ></Filters>
                    </Panel>
                </div>
            </form>
        );
    }

}

export default MyMatterList;
